import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

// ANT DESIGN IMPORTS
import { Input, Row, Typography, Card, Table, Spin, Select } from "antd";
import { ArrowDownOutlined } from "@ant-design/icons";

// PROJECT IMPORTS
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import { rightAction } from "../../../redux/actions";
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import { labelConfig, staticConfig, apiConfig } from "../product.config";

const rowSelection = {
  getCheckboxProps: (record) => ({
    disabled: record.name === "Disabled User",
    name: record.name,
  }),
};

const columns = [
  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Name"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "name",
    sorter: (a, b) => a.name.localeCompare(b.name),
  },
  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Short Name"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "shortName",
    sorter: (a, b) => a["shortName"].localeCompare(b["shortName"]),
  },

  {
    title: (column) => (
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {"Currency"}
        <div>
          <ArrowDownOutlined style={{ fontSize: 15, color: "gray" }} />
        </div>
      </div>
    ),
    dataIndex: "currency",
    sorter: (a, b) => a["currency"].localeCompare(b["currency"]),
  },
];

const PRD0100 = (props) => {
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [casaList, setCasaList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_SAVINGSPRODUCT") && getCasaListAction();
    BOM.HasPermission("CREATE_SAVINGSPRODUCT") &&
      rightAction(cnt.RIGHT_ADD_BTN);
    // dispatch({ type: cnt.CLEAR_RIGHT_BTN, });
  }, []);

  //DECLARED METHODS
  function handleSearchInTable(searchKey) {
    searchKey = searchKey.target.value;
    // console.log(searchKey);

    if (!searchKey) {
      setCasaList(originalList);
      return;
    }
    // console.log(originalList);
    const filterBySearch = originalList.filter(
      (item) =>
        item?.name.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.shortName.toLowerCase()?.includes(searchKey.toLowerCase()) ||
        item?.currency.toLowerCase()?.includes(searchKey.toLowerCase())
    );
    // console.log(filterBySearch);
    setCasaList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  const getCasaListAction = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.GetCasaProductList, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            name: element?.name ? element?.name : "-",
            shortName: element?.shortName ? element?.shortName : "-",
            currency: element?.currency ? element?.currency?.displayLabel : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setCasaList(tempArray.filter((item) => item.disabled === false));
        setCasaList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      BOM.FetchReqAction(body, apiConfig.GetCasaProductList, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              name: element?.name ? element?.name : "-",
              shortName: element?.shortName ? element?.shortName : "-",
              currency: element?.currency
                ? element?.currency?.displayLabel
                : "-",
            });
          });
          resolve(tempArray);
        }
      });
    });
  };

  // FLOAT METHODS
  function handleOnView() {
    // console.log(selectedRow);return
    delete selectedRow.amount;
    selectedRow.amount = selectedRow.amountToUse;
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-prd0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-prd0100", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-prd0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to edit");
    }
  }

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_SAVINGSPRODUCT") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_SAVINGSPRODUCT") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.CASAProducts}
        pageItems={staticConfig.casaProductItems}
      />

      <Card
        title={`${labelConfig.CASAProduct} List`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/*RENDER TABLE LIST HERE*/}

        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                placeholder="Search by Name, Short Name and Currency"
                style={{
                  width: 400,
                }}
              />
            </div>
            <DownloadTableButtons
              downloadData={casaList}
              columns={columns}
              fileName={"CASA Product List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              ...rowSelection,
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={casaList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};
const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(PRD0100);
